<template>
    <v-app id="inspire" class="changeFont">
        <progress-dialog />
        <system-bar />
        <router-view />
    </v-app>
</template>

<script>
import ProgressDialog from '@/components/commons/ProgressDialog.vue'
import SystemBar from '@/components/commons/SystemBar.vue'

export default {
    name: 'App',
    components: {
        ProgressDialog,
        SystemBar
    },
}
</script>

<style lang="scss">
    html {
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue